import { BootstrapToolTip } from '@/_elements/ToolTip';
import { ActionStyles } from '@/components/Admin/reusableStyles';
import { css } from '@emotion/react';
import { BsArrowBarRight, BsEye } from 'react-icons/bs';
import { VscLoading } from 'react-icons/vsc';
import ChangeVisitLabel from '../Label/ChangeVisitLabel';
import { statusData } from '../Label/_colorData';

export const VisitRedirectToChannel = ({ visit = {} }) => {
    const channelId = (visit?.client || {})?.chatroom || visit?.extraInfo?.chatroom;
    const formId = visit?.extraInfo?.formId;

    return (
        <BootstrapToolTip
            text={'Redirect to channel'}
            cssStyles={'top:-70% !important; min-width: 126px !important; left: -15px !important;'}
        >
            <ActionStyles>
                <a
                    href={`/teams/${channelId}${formId ? `/#/form/${formId}` : ''}`}
                    className={`${channelId ? '' : 'disabled'} btn btn-link`}
                    css={css`
                        margin: 0 !important;
                        padding: 0 !important;
                    `}
                >
                    <BsArrowBarRight className="icon edit" />
                </a>
            </ActionStyles>
        </BootstrapToolTip>
    );
};

export const VisitChangeLabelAction = ({ isLabelChanging = false, onChangeLabel, labels, teamDetails, teamId }) => {
    return (
        <BootstrapToolTip text="Change Label">
            <ActionStyles>
                {isLabelChanging ? (
                    <span className="icon edit d-flex justify-content-center align-items-center ">
                        <VscLoading className=" spin" />
                    </span>
                ) : (
                    <ChangeVisitLabel
                        handleLabelChange={onChangeLabel}
                        labels={labels}
                        teamDetails={teamDetails}
                        teamId={teamId}
                    />
                )}
            </ActionStyles>
        </BootstrapToolTip>
    );
};

export const VisitView = ({ visit, visitData, handleShow = () => {} }) => {
    return (
        <BootstrapToolTip text={visit?.extraInfo?.latestComment || visit?.extraInfo?.memo || 'View'} side="left">
            <ActionStyles className="view-icon">
                <BsEye className="icon" onClick={() => handleShow(visitData, 'data')} />
            </ActionStyles>
        </BootstrapToolTip>
    );
};

export const VisitStatus = ({ isLabelChanging, visitData = {} }) => {
    return (
        <span
            className="badge badge-sm"
            css={css`
                background: ${statusData[visitData?.status]};
                color: white;
                opacity: ${isLabelChanging ? 0.5 : 1};
                font-size: 12px !important;
            `}
        >
            {visitData?.status?.replaceAll('_', ' ') || 'complete'}
        </span>
    );
};
